import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import CloseIcon from '@mui/icons-material/Close';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const BulkPaymentLayout = ({
    children,
    headerContent = {},
    handleBack,
    stepper = null,
    currentStep,
}) => {
    const imageBaseUrl = useSelector(state => state.config.image_base_url);
    const navigate = useNavigate();
    const headerLogo = sessionStorage.getItem('logo');

    return (
        //absolute top-0 left-0 right-0
        <div className="w-screen h-screen flex flex-col z-20">
            <div className="hidden lg:flex py-[1rem] px-4 items-center flex-wrap lg:flex-nowrap justify-around  bg-[#26272B] border-b border-white/10 rounded-bl-lg rounded-br-lg">
                <div className="text-sm font-semibold tracking-wide hidden lg:block">
                    <img
                        src={headerLogo || `${imageBaseUrl}/junoclient/juno-icon.svg`}
                        alt="logo"
                        data-e2e="juno-img"
                        className={`w-[50.254329681396484px] h-[32px] ${
                            headerLogo
                                ? ''
                                : 'object-contain xxs:brightness-0 xxs:dark:invert lg:invert'
                        }`}
                    />
                </div>
                {stepper && <div className="flex-1">{stepper}</div>}
                <button
                    className="text-white hidden lg:block"
                    type="button"
                    onClick={() => navigate(-1)}
                >
                    <CloseIcon data-e2e="close-icon" />
                </button>
            </div>

            <div className="lg:hidden py-[1rem] px-4 items-center flex-wrap lg:flex-nowrap justify-around  dark:bg-[#26272B] bg-[#fff] border-b dark:border-white/10 border-black/10 rounded-bl-lg rounded-br-lg mb-1">
                <div className="flex">
                    {headerContent?.isBack && (
                        <button onClick={handleBack} className="text-text">
                            <ArrowBackIcon className="mr-[10px]" />
                        </button>
                    )}
                    {headerContent?.title && (
                        <p className="text-lg uppercase self-center font-semibold text-text m-auto">{headerContent.title}</p>
                    )}
                </div>
                {stepper && <div className="flex-1 mt-4">{stepper}</div>}
            </div>

            {/* Content */}
            <div
               className={`flex-1 flex items-start bg-rootStyle-bg ${currentStep !== 2 ? 'justify-center md:items-center' : 'w-full'}`}>
                {children}
            </div>
        </div>
    );
};

export default BulkPaymentLayout;